<template>
  <div>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-4" v-if="workflowId !== 3" >
        <div class="form-group "  >
          <label for="reward_desc" class="">pre-set-reward
            <span v-if="errorRewardDescr" class="error">{{ errorRewardDescr }}</span>
          </label>
          <input id="reward_desc" class="form-control" v-model="question.reward_descr" :class="{'has-error' : errorRewardDescr, 'has-success' : errorRewardDescr === false}">
          <span class="help-block m-b-none" style="margin-bottom: 10px">You can state a reward -or a range- you are ready to pay once your question is properly answered.</span>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12" :class="workflowId !== 3?'col-md-4':'col-md-6'" >
        <div class="form-group " >
          <label for="keywords" class="">Keywords
            <span v-if="errorKeywords" class="error">{{ errorKeywords }}</span>
          </label>
          <input id="keywords" class="form-control" v-model="question.keywords" :class="{'has-error' : errorKeywords, 'has-success' : errorKeywords === false}">
          <span class="help-block m-b-none" style="margin-bottom: 10px" v-if="workflowId === 3"> To help with the retrieval of your Tech offer </span>
          <span class="help-block m-b-none" style="margin-bottom: 10px" v-else> To help with the retrieval of your question </span>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12" :class="workflowId !== 3?'col-md-4':'col-md-6'" >
        <div class="form-group">
          <label>Picture
            <span v-if="errorPicture" class="error">{{ errorPicture }}</span>
          </label>
          <div class="row" v-if="question.picture">
            <div  class="col-xs-12">
              <div class="hpanel">
                <div class="panel-heading" style="height: 40px">
                  <div class="pull-right">
                    <button type="button" class="btn btn-danger btn-xs btn-outline" @click="removeFile"><i class="fa fa-remove"></i> Remove</button>
                  </div>
                </div>
                <a :href="$apiUrl + question.picture" target="_blank">

                  <template v-if="/(jpg|jpeg|png)$/ig.test(question.picture)">
                    <div class="panel-body file-body" style="padding: 10px">
                      <div style="height: 150px; max-width: 100%">
                        <img :src="$apiUrl + question.picture" width="100%" style="max-height: 150px" :title="question.picture.match('.*\/(.*)')[1]">
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="panel-body file-body" style="padding: 57px">
                      <template v-if="/(pdf)$/ig.test(question.picture)">
                        <i class="fa fa-file-pdf-o text-danger"></i>
                      </template>
                      <template v-else-if="/(doc|docx)$/ig.test(question.picture)">
                        <i class="fa fa-file-word-o text-info"></i>
                      </template>
                      <template v-else-if="/(xlsx|xlsm|xlsb|xls)$/ig.test(question.picture)">
                        <i class="fa fa-file-excel-o text-success"></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-file-o text-dark"></i>
                      </template>

                    </div>
                  </template>
                </a>
                <div class="panel-footer">
                  <a :href="$apiUrl + question.picture" target="_blank">{{question.picture.match('.*\/(.*)')[1]}}</a>
                </div>

              </div>
            </div>
          </div>
          <div class="example-btn">

            <label class="btn btn-primary btn-outline btn-sm file-uploads file-uploads-html5"><i class="fa fa-plus"></i>
              Select files <span v-if="uploadFiles.length !== 0">{{uploadFiles[0].name}} - {{uploadFiles[0].size}} kb</span>
              <input type="file" name="picture" style="display: none" accept="image/*" @change="onChange($event)">
            </label>
          </div>
          <span class="help-block m-b-none" style="margin-bottom: 10px">Illustrate your question to make it stand-out</span>
        </div>
      </div>

    </div>
    <div class="row">
      <div class="col-xs-12">
        <div class="form-group ">
          <div class="checkbox checkbox-info">
            <input id="is_public" type="checkbox" style="position: absolute; opacity: 0;" name="" v-model="question.is_public">
            <template v-if="workflowId ===3">
              <label for="is_public" class=""> Public Tech offer</label>
              <span class="help-block m-b-none" style="margin-bottom: 10px">Check this box if you want your Tech offer (title, overview ) to be published on the ideXlab web site to maximise its exposure.</span>
            </template>
            <template v-else>
              <label for="is_public" class=""> Public question</label>
              <span class="help-block m-b-none" style="margin-bottom: 10px">Check this box if you want your question (title, overview and reward if any) to be published on the ideXlab web site to maximise its exposure.</span>
            </template>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadFile from './UploadFile'
import VueLadda from 'vue-ladda'
export default {
  components: {UploadFile, VueLadda},
  name: 'QuestionStep3',
  props: ['projectId', 'question', 'workflowId'],
  data () {
    return {
      errorRewardDescr: null,
      errorKeywords: null,
      errorPicture: null,
      uploadFiles: []
    }
  },
  methods: {
    submitStep: function (requiredFields) {
      return new Promise((resolve, reject) => {
        let method = (this.question.id === null ? 'post' : 'patch')

        this.errorRewardDescr = null
        this.errorKeywords = null
        this.errorPicture = null

        this.upload().then((response) => {
          this.axios[method]('/question/' + (method === 'patch' ? this.question.id : ''), {
            project_id: this.projectId,
            step: 3,
            reward_descr: this.question.reward_descr,
            keywords: this.question.keywords,
            picture: this.question.picture,
            is_public: this.question.is_public,
            required_fields: requiredFields
          })
            .then((response) => {
              resolve(response)
            })
            .catch((error) => {
              reject(error)
              let errors = error.response.data.errors
              if (typeof errors['reward_descr'] !== 'undefined') {
                this.errorLongDescription = errors['reward_descr'][0]
              } if (typeof errors['keywords'] !== 'undefined') {
                this.errorTrl = errors['keywords'][0]
              } if (typeof errors['picture'] !== 'undefined') {
                this.errorTimeline = errors['picture'][0]
              }
            })
        })
          .catch((error) => {
            let errors = error.response.data.errors
            switch (error.response.data.code) {
              case 1:
                this.errorPicture = errors['files'][0]
                break
            }
            reject(error)
          })
      })
    },
    onChange: function (event) {
      this.uploadFiles = []

      this.uploadFiles.push(event.target.files[0])
    },
    removeFile: function () {
      if (typeof this.question.picture !== 'undefined') {
        this.axios.delete('file/question_picture/' + this.question.id)
          .then((response) => {
            this.$emit('input', Date.now())
          }).catch((error) => {

          })
      }
    },
    upload: function () {
      return new Promise((resolve, reject) => {
        if (this.uploadFiles.length !== 0) {
          let data = new FormData()

          this.uploadFiles.forEach((file) => {
            data.append('files[]', file)
          })
          data.append('target', 'question_picture')

          this.axios.post('/files/', data)
            .then((response) => {
              this.uploadFiles.forEach((file) => {
                if (typeof response.data.files[file.name] !== 'undefined') {
                  this.question.picture = response.data.path + response.data.files[file.name]
                }
              })
              this.uploadFiles = []
              resolve(response)
            })
            .catch((error) => {
              if (typeof error.response !== 'undefined' && error.response.status === 413) {
                this.$notify({
                  type: 'danger',
                  title: 'An error has occurred, max upload size is 10 Mo',
                  placement: 'bottom-right'
                })
              }
              reject(error)
            })
        } else {
          resolve(null)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/QuestionStep3.vue